// extracted by mini-css-extract-plugin
export default {"mainFooter":"Footer_mainFooter__8MWG3","footerHead":"Footer_footerHead__B-FZl","apps":"Footer_apps__Mkp7q","infoBox":"Footer_infoBox__VjgVG"};